import { Button, DeniedCardArt, ErrorScreen } from '@/components';
import { useAuth } from '@/features/auth/AuthProvider';
import { signOutOfFirebase } from '@/features/auth/signInWithGoogle';
import { useNavigate, useSearchParams } from '@solidjs/router';
import { Show } from 'solid-js';

export default function AuthorizeError() {
  const { firebaseUser, rejected, setRejected } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams<{ reason?: string }>();

  const disabled = () => params.reason === 'disabled';
  const email = () => rejected()?.email ?? firebaseUser()?.email ?? '(unknown)';

  const onSwitch = async () => {
    setRejected(null);
    await signOutOfFirebase();
    navigate('/login');
  };

  return (
    <ErrorScreen
      art={<DeniedCardArt stamp={disabled() ? 'DISABLED' : 'DENIED'} />}
      title={disabled() ? 'Account disabled' : 'Account not authorized'}
      body={
        <>
          <span class="font-mono">{email()}</span>{' '}
          {disabled()
            ? 'has been disabled by an administrator. Please contact an administrator.'
            : 'is not on the allowlist. Please contact an administrator.'}
        </>
      }
      action={
        <Show when={firebaseUser() || rejected()}>
          <Button size="lg" class="min-w-44 shadow-lg shadow-brand-600/30" onClick={onSwitch}>
            Sign out & try another account
          </Button>
        </Show>
      }
    />
  );
}
